class JobForm {
    constructor() {
        this.form = document.querySelector('.job-form form');
        if (this.form) {
            this.setupEventListeners();
        }
    }

    setupEventListeners() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            this.handleSubmit();
        });
    }

    async handleSubmit() {
        // Extraction des données du formulaire
        const formData = new FormData(this.form);
        const url = this.form.action;
        const method = this.form.method || 'POST';

        try {
            const response = await fetch(url, {
                method: method,
                body: formData
            });

            if (response.ok) {
                const result = await response.json(); // Ou response.text() selon ton API
                this.handleSuccess(result);
            } else {
                throw new Error(`Erreur serveur : ${response.status}`);
            }
        } catch (error) {
            this.handleError(error);
        }
    }

    handleSuccess(result) {
        this.form.dataset.sent = "true"
    }

    handleError(error) {
        console.error('Erreur lors de l\'envoi :', error);
        alert('Une erreur est survenue lors de l\'envoi.');
    }
}

export { JobForm };